import React, { ReactNode } from 'react';
import { AppSidebar } from "../sidebar/app-sidebar";
import {
  SidebarInset,
  SidebarProvider,
} from "./ui/sidebar";
import { NavigationProps, AppPage } from "@/types/navigation";

interface AppLayoutProps extends NavigationProps {
  children: ReactNode;
  currentPage?: AppPage;
}

export default function AppLayout({ children, onNavigate, currentPage }: AppLayoutProps) {
  return (
    <SidebarProvider>
      <AppSidebar onNavigate={onNavigate} currentPage={currentPage} />
      <SidebarInset>
        {children}
      </SidebarInset>
    </SidebarProvider>
  );
} 